import { FEATURE_CARDS as SHARED_FEATURE_CARDS } from '@repo/studio-components-feature-cards/feature-cards'
import type { FeatureCardData } from '@repo/studio-components-feature-cards/feature-cards'

export interface FeatureCard extends FeatureCardData {
  studioPath: string
}

const PATH_MAP: Record<string, string> = {
  image_editor: '/ai-image-editor',
  video_generator: '/ai-video-generator',
  nanobanana_2: '/flow',
  music_generator: '/ai-music-generator',
  logo_generator: '/logo-creator',
  seedream_2: '/ai-video-generator?model=seedance_two_point_zero',
  lyria_3: '/ai-music-generator',
}

export const FEATURE_CARDS: FeatureCard[] = SHARED_FEATURE_CARDS.map(card => ({
  ...card,
  studioPath: PATH_MAP[card.id] ?? '',
}))
